import axios from "axios";

const api = axios.create({
  baseURL: "https://cauverytours.in/cauverytours-backend/admin", // Change if your backend URL is different
});

export default api;
